export enum Environments {
  DEV = 'dev',
  TEST = 'test',
  ACC = 'acc',
  PROD = 'prod',
}
